<template lang="pug">
v-dialog(v-model="isModalVisible" max-width="600")
  v-card
    title-bar(dark) {{ dialogTitle }}
    v-card-text.pa-0
      div
        v-layout(column, align-center, justify-center).mt-4.mb-1
          p.dialog-text.mt-1.font-weight-bold {{ dialogBody }}
          v-layout.my-4(
            align-center
            justify-center
            row
            fill-height
          )
            v-btn.ml-0.close-btn(
              @click='close'
              flat
            )
              | Close
            v-btn.ml-0(color="primary" @click='goToBulkActionsReport')
              | Bulk Actions Report
</template>

<script>
import TitleBar from '@/Core/components/TitleBar';
import Modal from '@/Core/mixins/modal';
import { mapState } from 'vuex';

export default {
  name: 'BulkActionsInProgressModal',
  components: {
    TitleBar,
  },
  mixins: [Modal],
  data() {
    return {
      bulkInProgressModalVisible: true,
      defaultText: 'Your Bulk Action is in progress, you can review it on the Bulk Actions Report page, in the meantime you can close this window and continue using your CRM.',
    }
  },
  computed: {
    ...mapState({
      bulkActionType: state => state.contactsTable.bulkActions.bulkActionType,
    }),
    dialogTitle() {
      return this.bulkActionType ? `${this.bulkActionType} Bulk Action` : 'Review Bulk Action';
    },
    dialogBody() {
      if (this.bulkActionType === 'Cancel Campaign') {
        return `Your Bulk Action is in progress. Once completed, you can easily start a new campaign for these contacts within 30 days on Bulk Actions Report.`;
      }
      return this.defaultText;
    },
  },
  methods: {
    close() {
      this.isModalVisible = false;
    },
    show() {
      this.isModalVisible = true;
    },
    goToBulkActionsReport() {
      this.$router.push('/reporting/bulk-actions');
    },
  }
}
</script>

<style lang="scss" scoped>
.dialog-text {
  width: 550px;
}

.close-btn {
  color: var(--v-primary-base);
}

</style>
